import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { NotificationTypeEnum } from 'src/app/shared/enums/notification-type.enum';
import { NotificationEmail } from 'src/app/shared/models/notificationEmail';
import { Editor } from 'ngx-editor';

@Component({
	selector: 'app-notificationEmail-modal-detail',
	templateUrl: './notificationEmail-modal-detail.component.html',
	styleUrls: ['./notificationEmail-modal-detail.component.scss']
})
export class NotificationEmailModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		title: new FormControl('', [
			Validators.required
		]),
		type: new FormControl(''),
		message: new FormControl('', [
			Validators.required,
		]),
		actif: new FormControl()
	});

	notificationEmail: NotificationEmail;
	editor: Editor;
	notificationTypes = NotificationTypeEnum;
	keys = Object.keys;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.editor = new Editor();
		this.formEdit.setValue({
			title: this.notificationEmail ? this.notificationEmail.title : null,
			type: this.notificationEmail ? this.notificationEmail.type : null,
			message: this.notificationEmail ? this.notificationEmail.message : null,
			actif: this.notificationEmail ? this.notificationEmail.actif : true
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.notificationEmail.title = this.formEdit.get('title').value;
		this.notificationEmail.type = this.formEdit.get('type').value;
		this.notificationEmail.message = this.formEdit.get('message').value;
		this.notificationEmail.actif = this.formEdit.get('actif').value;
		this.facade.notificationEmailService.updateNotificationEmail(this.notificationEmail).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.notificationEmailService
			.deleteNotificationEmail(this.notificationEmail.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.notificationEmailService
			.deleteNotificationEmail(this.notificationEmail.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get title() {
		return this.formEdit.get('title');
	}

	get type() {
		return this.formEdit.get('type');
	}

	get message() {
		return this.formEdit.get('message');
	}
	get actif() {
		return this.formEdit.get('actif');
	}
}
